// src/Utils/MasterClassAuth.js
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const MasterClassAuth = ({ isAuthRoute = false }) => {
  const location = useLocation();
  const authToken = localStorage.getItem("auth_token");

  // If it's an auth route (login/signup etc.)
  if (isAuthRoute) {
    // If already logged in, redirect to dashboard/home
    return authToken ? (
      <Navigate to="/dating-masterclass/" replace />
    ) : (
      <Outlet />
    );
  }

  // If it's a protected route (main app area)
  return authToken ? (
    <Outlet />
  ) : (
    <Navigate to="/login/" state={{ from: location }} replace />
  );
};

export default MasterClassAuth;
